const typographyModalDocCompany = {
  true: 'Cadastrar Novo Documento',
  false: 'Editar Documento'
};

export default typographyModalDocCompany;
